// components/skeletons/SkeletonStudentReviewSection.js
export default function SkeletonStudentReviewSection() {
  return (
    <section
      className="student-review_section section_padding"
      aria-busy="true"
      aria-label="Loading student reviews"
    >
      <div className="container">
        {/* Title Skeleton */}
        <div
          className="student-review-title bg-[linear-gradient(90deg,rgba(3,53,62,0.05)_0%,rgba(3,53,62,0.02)_100%)] flex items-center space-x-4 mb-8"
          style={{ minHeight: "64px" }}
        >
          <div className="w-12 h-12 bg-gray-300 rounded-full animate-pulse"></div>
          <div className="h-8 w-48 bg-gray-300 rounded animate-pulse"></div>
        </div>

        {/* Reviews Slider Skeleton */}
        <div className="student-review-slider overflow-hidden">
          <div className="student-review flex space-x-6">
            {[1, 2, 3].map((_, idx) => (
              <div
                key={idx}
                className="student-review-card w-72 bg-white rounded-lg shadow-md p-4 flex flex-col animate-pulse"
                style={{ minHeight: "380px" }}
              >
                {/* Image Placeholder */}
                <div className="student-image-wrap mb-5 rounded-lg overflow-hidden bg-gray-300 h-48" />

                {/* Name and Designation */}
                <div className="video-content flex flex-col gap-2 flex-grow">
                  <div className="top">
                    <div className="h-6 w-32 bg-gray-300 rounded mb-2"></div>
                    <div className="h-5 w-20 bg-gray-300 rounded"></div>
                  </div>

                  {/* Short description */}
                  <div className="bottom mt-auto">
                    <div className="h-16 bg-gray-300 rounded" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <div className="student-arrow flex justify-between mt-6 px-4">
            <button
              aria-hidden="true"
              className="arrow-icon w-10 h-10 bg-gray-300 rounded-full animate-pulse"
            ></button>
            <button
              aria-hidden="true"
              className="arrow-icon w-10 h-10 bg-gray-300 rounded-full animate-pulse"
            ></button>
          </div>
        </div>
      </div>
    </section>
  );
}
